import React, { useContext, useEffect, useState } from "react";
import TableAgentGrowth from "components/TableAgentGrowth";
import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../config/axios";
import refactorStructureData from "../../helpers/refactorDataMenu";
import { RootContext } from '../../App'

const PlayerGrowth = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const { state, setState } = useContext(RootContext)

  const getData = () => {
    const token = localStorage.getItem("access_token");

    const group = JSON.parse(localStorage.getItem("group"))
    const data = {
      token: token,
      group: group.wbid,
      // user: username,      
      // lgth: length,
    }
    if (!token) {
      history.push("/login");
    } else {
      try {

        axiosInstance("player_grow_v2", {
          method: "POST",
          data,
        })
          .then((res) => {
            // console.log(res);
            setData(res.data.data.list)

            setState({
              ...state,
              group: res.data.data.additional_data.group,
              menu: refactorStructureData(res.data.data.additional_data.menu),
            });

          })
          .then(() => {
          })
          .catch((err) => {
            // localStorage.removeItem("access_token");
            // history.push("/login");
          });
      } catch (error) {
        console.log("ERROR: ", error);
      }
    }
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="bg-light-blue-500 pt-7 pb-28 px-3 md:px-8 h-auto"></div>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <Card>
              <CardHeader color="blueGray" contentPosition="left">
                <h2 className="text-white text-2xl">Player Growth</h2>
              </CardHeader>
              <TableAgentGrowth
                title="Player List"
                agentGrowth={data}
              />
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlayerGrowth;
